/* <rr-eta> — "CAST TO ORDER · ARRIVES 27 OCT – 5 NOV" (bloque price-parity, 18 oct 2026).
   Liquid ya la pinta con la fecha del servidor; aquí se rehace con la del cliente, porque
   la página puede venir de caché de días atrás. Hoy + fundición (días naturales,
   data-cast="7,14") + envío (días laborables, data-ship="1,4"). Los meses y la frase
   llegan traducidos. Sin dependencias. */
(() => {
  if (customElements.get('rr-eta')) return;

  const workdays = (date, n) => {
    const d = new Date(date);
    let left = n;
    while (left > 0) {
      d.setDate(d.getDate() + 1);
      const wd = d.getDay();
      if (wd !== 0 && wd !== 6) left -= 1;
    }
    return d;
  };

  class RREta extends HTMLElement {
    connectedCallback() {
      const months = (this.dataset.months || '').split(' ');
      const [castMin, castMax] = (this.dataset.cast || '').split(',').map(Number);
      const [shipMin, shipMax] = (this.dataset.ship || '').split(',').map(Number);
      const tpl = this.dataset.template;
      if (months.length !== 12 || !tpl || [castMin, castMax, shipMin, shipMax].some(Number.isNaN)) return;
      const label = (cast, ship) => {
        const d = new Date();
        d.setDate(d.getDate() + cast);
        const end = workdays(d, ship);
        return `${end.getDate()} ${months[end.getMonth()]}`;
      };
      this.textContent = tpl.replace('__FROM__', label(castMin, shipMin)).replace('__TO__', label(castMax, shipMax));
    }
  }

  customElements.define('rr-eta', RREta);
})();
